module.exports = __webpack_public_path__ + "media/images/delete-e965e21c.png";